// extracted by css-extract-rspack-plugin
export default {"main":"main-CKCpfF"};